export enum CacheKeys {
  internalEnvironments = "internalEnvironments",
  environments = "environments",
  environmentVersion = "environmentVersion",
  iterations = "iterations"
}
